require(['./main']);
require(['bwp', 'recaptcha'], function($)
{

});
define("theme", function(){});

